// import React, { useContext, useEffect, useState } from "react";
// import css from "../css/Mywallet.module.css";
// import Rightcontainer from "../Components/Rightcontainer";
// import { Link, useHistory } from "react-router-dom";
// import axios from "axios";
// import socket from "../Components/socket";
// import { AiOutlineHistory, AiOutlinePlus } from "react-icons/ai";
// import { BsWallet2 } from "react-icons/bs";
// import io from "../Components/socket";
// import { LanguageContext } from "../Components/LanguageContext";
// import { useTheme } from "../../ThemeContext";
// import { VscReferences } from "react-icons/vsc";

// const Mywallet = ({ user }) => {
//   // const [user, setUser] = useState();

//   const access_token = localStorage.getItem("token");
//   //   const walletUpdate =()=>{
//   //  io.emit("getprofile", access_token);
//   //   io.on("setProfile", (data) => {
//   //     setUser(data);
//   //   });
//   //   }

//   //   useEffect(()=>{
//   //     walletUpdate()
//   //   },[]);

//   // language
//   const translations = {
//     hi: {
//       wallet: "वॉलेट",
//       history: "इतिहास देखे | ",
//       amount: "पैसे जोड़ें | ",
//       withdraw: "पैसे निकाले  | ",
//       referPerson: "रेफ़रल | ",
//     },
//     en: {
//       wallet: "My Wallet",
//       history: "Order History",
//       amount: "Add Cash",
//       withdraw: "Withdraw",
//       referPerson: "Referral",
//     },
//   };

//   const { language } = useContext(LanguageContext);

//   // change theme
//   const theme = localStorage.getItem("theme");

//   const styles = {
//     backgroundColor: theme === "light" ? "#d3e3fd" : "#000",
//     color: theme === "light" ? "black" : "#fff",
//   };

//   return (
//     <>
//       <div
//         className="leftContainer mb_space"
//         style={{ ...styles, height: "100vh" }}
//       >
//         <div className="balance-section pt-2 mt-5 Orher_page_main_section">
//           <div className="mt-2">
//             <h3 className="mb-3">Balance</h3>

//             {/* Deposit Cash Card */}
//             <div className="unique-card">
//               <div className="unique-card-left">
//                 <img src="/images/deposit.png" className="card-main-img" />
//               </div>

//               <div className="unique-card-right">
//                 <h2 className="uc-title">Deposit Cash</h2>

//                 <div className="uc-amount">
//                   <img src="/rupee.png" className="rupee-icon" />
//                   <b>{user && user.Wallet_balance - user.withdrawAmount}</b>
//                 </div>

//                 <Link to="/addcase">
//                   <button className="uc-btn">
//                     <AiOutlinePlus className="icons" />{" "}
//                     {translations[language].amount}
//                   </button>
//                 </Link>
//               </div>
//             </div>

//             {/* Winning Cash Card */}
//             <div className="unique-card win">
//               <div className="unique-card-left">
//                 <img
//                   src="/images/win-cash.png"
//                   className="card-main-img"
//                   style={{ transform: "scale(1.5)" }}
//                 />
//               </div>

//               <div className="unique-card-right">
//                 <h2 className="uc-title">Winning Cash</h2>

//                 <div className="uc-amount text-danger">
//                   <img src="/rupee.png" className="rupee-icon" />
//                   <b>{user && user.withdrawAmount}</b>
//                 </div>

//                 <Link to="/Withdrawopt">
//                   <button className="uc-btn withdraw">
//                     <BsWallet2 className="icons" />{" "}
//                     {translations[language].withdraw}
//                   </button>
//                 </Link>
//               </div>
//             </div>
//           </div>
//         </div>

//         <div className="rightContainer">
//           <div>
//             <Rightcontainer />
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };
// export default Mywallet;


import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { LanguageContext } from "../Components/LanguageContext";
import Rightcontainer from "../Components/Rightcontainer";

const Mywallet = ({ user }) => {
  const { language } = useContext(LanguageContext);

  const translations = {
    hi: {
      status: "खाता स्थिति",
      verified: "सत्यापन पूरा हुआ",
      deposit: "डिपॉजिट चिप्स",
      winnings: "विनिंग चिप्स",
      availablePlay: "खेलने के लिए उपलब्ध",
      withdrawBal: "निकालने योग्य शेष",
      add: "Add Chips",
      withdraw: "Withdraw",
      secure: "आपके ट्रांजैक्शन 100% सुरक्षित और एन्क्रिप्टेड हैं।",
    },
    en: {
      status: "Account Status",
      verified: "Verification Completed",
      deposit: "Deposit Chips",
      winnings: "Winning Chips",
      availablePlay: "Available for play",
      withdrawBal: "Withdrawable balance",
      add: "Add Chips",
      withdraw: "Withdraw",
      secure: "Your transactions are 100% secure and encrypted.",
    },
  };

  const t = translations[language] || translations.en;

  const depositAmount = user ? (user.Wallet_balance - user.withdrawAmount).toFixed(2) : "0.00";
  const winningAmount = user ? user.withdrawAmount.toFixed(2) : "0.00";

  return (
    <>
      {/* Inline Style Block for Keyframes, Hover Effects, and Mobile responsiveness */}
      <style>
        {`
          .premium-wallet-container {
            background: linear-gradient(135deg, #0a0f1c 0%, #000000 100%);
            min-height: 100vh;
            color: #ffffff;
            font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
            overflow-x: hidden;
          }
          
          .float-anim {
            animation: floatUpDown 3s ease-in-out infinite;
          }
          
          .pulse-glow {
            animation: pulseGlow 2s infinite;
          }

          .slide-up {
            animation: slideUp 0.6s ease-out forwards;
          }

          .glass-card {
            background: rgba(20, 25, 40, 0.7);
            backdrop-filter: blur(10px);
            border-radius: 16px;
            border: 1px solid rgba(255, 255, 255, 0.08);
            box-shadow: 0 15px 35px rgba(0,0,0,0.5);
            transition: transform 0.3s ease;
          }

          .glass-card:hover {
            transform: translateY(-5px);
          }

          .btn-hover:hover {
            transform: scale(1.05);
            box-shadow: 0 5px 15px rgba(255, 215, 0, 0.4);
          }

          /* Force cards side-by-side even on small phone screens */
          .cards-grid {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            gap: 15px;
            width: 100%;
          }

          @media (max-width: 600px) {
            .cards-grid {
              gap: 10px;
            }
            .wallet-card {
              padding: 15px 10px !important;
            }
            .card-amount {
              font-size: 1.2rem !important;
            }
            .card-title {
              font-size: 0.8rem !important;
            }
            .action-btn {
              padding: 8px 10px !important;
              font-size: 0.8rem !important;
            }
          }

          @keyframes floatUpDown {
            0% { transform: translateY(0px); }
            50% { transform: translateY(-10px); }
            100% { transform: translateY(0px); }
          }

          @keyframes pulseGlow {
            0% { box-shadow: 0 0 0 0 rgba(255, 215, 0, 0.4); }
            70% { box-shadow: 0 0 0 10px rgba(255, 215, 0, 0); }
            100% { box-shadow: 0 0 0 0 rgba(255, 215, 0, 0); }
          }

          @keyframes slideUp {
            from { opacity: 0; transform: translateY(20px); }
            to { opacity: 1; transform: translateY(0); }
          }
        `}
      </style>

      <div className="premium-wallet-container leftContainer mt-5 pt-5" style={{ display: 'flex', flexWrap: 'wrap' }}>
        <div style={{ flex: '1 1 100%', maxWidth: '800px', margin: '0 auto', padding: '20px' }}>
          
          {/* Header & GIF Section */}
          <div style={{ textAlign: 'center', marginBottom: '30px' }} className="slide-up">
            <img 
              src="https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExM2I4Y2QxZjc1MmY0MTI4ODcxMDU1M2Y2Y2RiYTZjZGI3MThjZjhhZCZlcD12MV9pbnRlcm5hbF9naWZzX3NlYXJjaCZjdD1n/L1R1tvI9svkVDsPRkL/giphy.gif" 
              alt="Gold Coin" 
              className="float-anim"
              style={{ width: '80px', height: '80px', objectFit: 'contain', filter: 'drop-shadow(0px 10px 10px rgba(255,215,0,0.3))' }}
            />
            <h2 style={{ fontSize: '28px', fontWeight: 'bold', margin: '10px 0 5px 0', color: '#fff' }}>
              My <span style={{ color: '#ffd700' }}>Wallet</span>
            </h2>
          </div>

          {/* Verification Status Banner */}
          <div 
            className="glass-card slide-up" 
            style={{ display: 'flex', alignItems: 'center', padding: '15px 20px', marginBottom: '25px', borderLeft: '4px solid #00ff88', animationDelay: '0.1s' }}
          >
            <div style={{ position: 'relative', marginRight: '15px' }}>
              <img src="/avatarwallet.png" alt="user" style={{ width: '50px', height: '50px', borderRadius: '50%', border: '2px solid #00ff88' }} />
              <div style={{ position: 'absolute', bottom: '-5px', right: '-5px', background: '#00ff88', color: '#000', borderRadius: '50%', width: '20px', height: '20px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '12px', fontWeight: 'bold' }}>
                ✓
              </div>
            </div>
            <div>
              <div style={{ color: '#8892b0', fontSize: '12px', textTransform: 'uppercase', letterSpacing: '1px' }}>{t.status}</div>
              <div style={{ color: '#00ff88', fontSize: '16px', fontWeight: 'bold' }}>{t.verified}</div>
            </div>
          </div>

          {/* Balance Cards (Side by Side) */}
          <div className="cards-grid slide-up" style={{ animationDelay: '0.2s' }}>
            
            {/* Deposit Card */}
            <div className="glass-card wallet-card" style={{ flex: '1', padding: '25px', borderTop: '3px solid #00bfff' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
                <span className="card-title" style={{ color: '#00bfff', fontWeight: '600', fontSize: '14px' }}>{t.deposit}</span>
                <div style={{ background: 'rgba(0, 191, 255, 0.2)', color: '#00bfff', width: '30px', height: '30px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold' }}>₹</div>
              </div>
              <div className="card-amount" style={{ fontSize: '28px', fontWeight: '800', marginBottom: '5px' }}>₹{depositAmount}</div>
              <div style={{ fontSize: '11px', color: '#8892b0', marginBottom: '20px' }}>{t.availablePlay}</div>
              <Link 
                to="/addcase" 
                className="action-btn btn-hover" 
                style={{ display: 'block', textAlign: 'center', background: 'linear-gradient(90deg, #00bfff, #0077ff)', color: '#fff ', textDecoration: 'none', padding: '12px', borderRadius: '8px', fontWeight: 'bold', transition: 'all 0.3s' }}
              >
                {t.add}
              </Link>
            </div>

            {/* Winnings Card */}
            <div className="glass-card wallet-card" style={{ flex: '1', padding: '25px', borderTop: '3px solid #ffd700' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
                <span className="card-title" style={{ color: '#ffd700', fontWeight: '600', fontSize: '14px' }}>{t.winnings}</span>
                <div style={{ background: 'rgba(255, 215, 0, 0.2)', color: '#ffd700', width: '30px', height: '30px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold' }}>₹</div>
              </div>
              <div className="card-amount" style={{ fontSize: '28px', fontWeight: '800', marginBottom: '5px' }}>₹{winningAmount}</div>
              <div style={{ fontSize: '11px', color: '#8892b0', marginBottom: '20px' }}>{t.withdrawBal}</div>
              <Link 
                to="/Withdrawopt" 
                className="action-btn btn-hover pulse-glow" 
                style={{ display: 'block', textAlign: 'center', background: 'linear-gradient(90deg, #ffd700, #ffaa00)', color: '#000', textDecoration: 'none', padding: '12px', borderRadius: '8px', fontWeight: 'bold', transition: 'all 0.3s' }}
              >
                {t.withdraw}
              </Link>
            </div>

          </div>

          {/* Secure Footer */}
          <div className="slide-up" style={{ textAlign: 'center', marginTop: '30px', animationDelay: '0.3s' }}>
            <p style={{ color: '#4a5568', fontSize: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
              <span style={{ fontSize: '16px' }}>🔒</span> {t.secure}
            </p>
          </div>

        </div>

        <div className="rightContainer mobile-hide" style={{ flex: '0 0 auto' }}>
          <Rightcontainer />
        </div>
      </div>
    </>
  );
};

export default Mywallet;